<template>
  <Highchart
    :options="options"
    class="transition duration-150 ease-in-out"
    :class="{ 'opacity-80 blur-md filter': loading }"
  />
</template>

<script setup lang="ts">
import { Chart as Highchart } from "highcharts-vue";

defineProps({
  options: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>
